import { useAuth0 } from "@auth0/auth0-react";
import { Button } from "@mui/material";
import { useSearchParams } from "react-router";

import { getFrontendUrl, clearCaches } from "@/utils/util";
import "@/components/LoginScreen/LoginScreen.css";

const LoginButton = () => {
  const { loginWithRedirect, isAuthenticated } = useAuth0();
  const [searchParams] = useSearchParams();

  const handleLoginWithWithRedirect = async () => {
    clearCaches();

    const invitation = searchParams.get("invitation"),
      organization = searchParams.get("organization"),
      organization_name = searchParams.get("organization_name");
    if (invitation && organization && organization_name) {
      await loginWithRedirect({
        invitation,
        organization,
        organization_name,
        redirect_uri: getFrontendUrl(),
      });
    } else {
      await loginWithRedirect();
    }
  };

  return (
    !isAuthenticated && (
      <Button
        className="sitePurple login-button"
        onClick={handleLoginWithWithRedirect}
      >
        Log In
      </Button>
    )
  );
};

export default LoginButton;
